module.exports = __webpack_public_path__ + "static/media/telkom.56be9ae3.png";